import React from "react";
import { Target, Zap, ShieldCheck, BarChart3 } from "lucide-react";
import { WHY_US } from "../../data/constants";

const ICONS = { Target, Zap, ShieldCheck, BarChart3 };

export default function WhyUsSection() {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="relative border-b border-white/10 bg-[#0B0F19]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-32">
        {/* Header strip */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-14 md:mb-20">
          <div className="md:col-span-4">
            <p className="text-[10px] font-bold uppercase tracking-[0.35em] text-[#F47B20] mb-4">
              / 01 — Why Shoolin
            </p>
            <h2 className="font-display font-black uppercase tracking-tighter text-white text-4xl sm:text-5xl md:text-6xl leading-[0.95]">
              We don't <span className="text-[#F47B20]">sell tools.</span> We
              ship outcomes.
            </h2>
          </div>
          <div className="md:col-span-7 md:col-start-6">
            <p className="text-white/70 text-base md:text-lg leading-relaxed">
              ERP rollouts, integrations, websites and brand campaigns are
              easier to <em className="not-italic text-white">start</em> than to
              actually finish. Our consultants own delivery end-to-end — picking
              the right stack, building it cleanly and staying around long
              enough for it to compound.
            </p>
          </div>
        </div>

        {/* 4-card grid with 1px borders */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/10">
          {WHY_US.map((item, idx) => {
            const Icon = ICONS[item.icon] || Target;
            return (
              <div
                key={idx}
                data-testid={`why-card-${idx}`}
                className="card-lift relative group border-r border-b border-white/10 p-8 md:p-10 bg-[#0B0F19]"
              >
                <div className="inline-flex items-center justify-center w-12 h-12 border border-[#F47B20]/40 text-[#F47B20] mb-6 group-hover:bg-[#F47B20] group-hover:text-black transition-colors">
                  <Icon className="w-5 h-5" strokeWidth={2.2} />
                </div>
                <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/40 mb-3">
                  0{idx + 1}
                </p>
                <h3 className="font-display text-xl md:text-2xl font-bold text-white leading-tight mb-3">
                  {item.title}
                </h3>
                <p className="text-sm text-white/65 leading-relaxed">{item.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
